import InviteAffiliateContainer from './InviteAffiliateContainer';

export {
    InviteAffiliateContainer
};

export default InviteAffiliateContainer;